import { FC, ReactElement } from "react";

import { POTENTIAL_TABS } from "@/constants";
import { RouterTabs } from "@/components";

const PotentialSavingTabs: FC = (): ReactElement => {
  return <RouterTabs tabs={POTENTIAL_TABS} />;
};

export default PotentialSavingTabs;

// Re-export the components for routing
export { default as FirstSale } from "./first-sale";
export { default as PreferentialOrigin } from "./preferential-origin";
export { default as FTZ } from "./ftz";
export { default as MTB } from "./mtb";
export { default as Exclusions } from "./exclusions";
